import React from 'react';
import MuiTextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import CONSTANTS from '../../utils/constants/UIConstants';

interface MultipleLineTextFieldProps {
    label?: string;
    value?: string | number;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onKeyDown?: (e: React.KeyboardEvent<HTMLDivElement>) => void;
    inputProps?: React.ComponentProps<typeof MuiTextField>['inputProps'];
    preview?: boolean; // For a non-editable preview mode
    disabled?: boolean; // To disable the input
    rows?: number; // Number of rows for multi-line input
    addStyle?: string; // Tailwind CSS class
}

const StyledTextField = styled(MuiTextField)(({ theme }) => ({
    width: '100%', // Adjust width to fit the container
    borderRadius: '2px',
    fontFamily: 'inter, sans-serif !important',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.17px',
    textAlign: 'left',
    backgroundColor: 'white',
    '& .MuiOutlinedInput-root': {
        borderColor: '#9EACB4', // Default border
        '&:hover': {
            borderColor: '#9EACB4', // Adds border on hover
        },
        '&.Mui-focused': {
            borderColor: '#9EACB4', // Adds border when the input is focused
        },
        '&.Mui-disabled': {
            color: '#556670',
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'transparent',
            },
            '& .MuiSelect-icon': {
                display: 'none',
            },
        },
    },
    '.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderRadius: '2px', 
  },
    '& .MuiInputBase-input.Mui-disabled': {
      WebkitTextFillColor: '#2C2C2C',
    },
    '.MuiFormLabel-root': {
      color: '#556670',
    },
    '& .MuiInputLabel-outlined': {
        transform: 'translate(14px, 10px) scale(1)', // Adjust label position for empty field
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        transform: 'translate(14px, -8px) scale(0.75)', // Adjust label position when field is focused or filled
    },
    
}));

const MultipleLineTextField: React.FC<MultipleLineTextFieldProps> = ({
    label,
    value,
    onChange,
    onKeyDown,
    inputProps,
    preview,
    disabled,
    rows,
    addStyle,
}) => {
    if (preview) {
        return (
            <div
                className={`font-inter text-base font-semibold leading-6 text-left ${addStyle}`}
            >
                {value}
            </div>
        );
    }

    return (
        <StyledTextField
            variant="outlined"
            label={label}
            value={value}
            onChange={onChange}
            onKeyDown={onKeyDown}
            inputProps={inputProps}
            disabled={disabled}
            multiline
            rows={rows}
            className={addStyle}
            sx={{
                '& .MuiInputLabel-root': {
                    maxWidth: label ? (label.length >= 10 ? '130%' : '100%') : '100%',
                    backgroundColor: CONSTANTS.TEXT_INPUT_LABEL_BACKGROUND,
                    padding: '0.25rem 0.35rem 0 0.35rem',
                    marginLeft: '-0.35rem',
                    marginTop: '-0.10rem',
                    borderRadius: '5px',
                },
            }}
        />
    );
};

export default MultipleLineTextField;